import { Component, Input } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { map } from 'rxjs/operators';
import { ActivityTypeService, IActivityType, Page } from 'src/app/xena-api';

@Component({
    selector: 'app-activity-type-mapping',
    templateUrl: './activity-type-mapping.component.html',
    styleUrls: ['./activity-type-mapping.component.scss'],
    standalone: false
})
export class ActivityTypeMappingComponent {
  @Input() activityTypeMappings: UntypedFormArray;

  constructor(private activityTypeService: ActivityTypeService) { }

  activityTypeDatasource = (queryString: string): Promise<IActivityType[]> =>
    this.activityTypeService.list({ queryString, forceNoPaging: false })
      .pipe(map((x: Page<IActivityType>) => x.entities))
      .toPromise();
}
